module.exports = __webpack_public_path__ + "static/media/ade.8b591655.jpg";